import {Collapse} from "bootstrap";

function addDataTitleToTableCells() {
  const accordionItems = document.querySelectorAll('.catalog-module .accordion-item');

  accordionItems.forEach(accordionItem => {
    const table = accordionItem.querySelector('table');
    if (!table) {
      return;
    }

    const thElements = table.querySelectorAll('thead th');
    const tdElements = table.querySelectorAll('tbody td');

    if (thElements.length === 0) {
      accordionItem.classList.add('noMobileView');
      return;
    }

    tdElements.forEach(td => {
      const cellIndex = td.cellIndex;
      if (thElements[cellIndex]) {
        td.setAttribute('data-title', thElements[cellIndex].textContent.trim());
      }
    });
  });
}
// Call the function when the page loads
window.addEventListener('load', addDataTitleToTableCells);
